import { render } from "./TheSubscriptionAlert.vue?vue&type=template&id=56c2c00c"
import script from "./TheSubscriptionAlert.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__